import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuszugPrintOptions, AuszugSettingsService } from './auszug-settings-service';
import { FormatConfigService } from '../../../../core/services/format-config.service';
import { GrundstueckPrintOptionsMeta } from '../../../../core/gb-api';
import { AuszugInfoItem, AuszugTypeEnum, FormatEnum } from '../auszug-print-service';
import { ErweiterungConfigResponse } from '../../../../core/base-api';
import { AppPermissionService } from 'app/core/services/app-permission.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CapAlertService } from '../../../../core/extension/exceptions/cap-alert.service';
import { FormsModule } from '@angular/forms';
import { CapFormColumnsDirective } from '../../../form-control/form-columns.directive';
import { MetaDirective } from '../../../directives/meta.directive';
import { CapFormControlComponent } from '../../../form-control/form-control.component';
import { MetaDisablerDirective } from '../../../directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../directives/meta-validator.directive';
import { Subscription } from 'rxjs';
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

@Component({
  selector: 'cap-grundstueck-auszug-settings',
  templateUrl: './grundstueck-auszug-settings.component.html',
  styleUrls: ['./auszug-settings.component.scss'],
  imports: [
    TranslatePipe,
    FormsModule,
    CapFormColumnsDirective,
    MetaDirective,
    CapFormControlComponent,
    MetaDisablerDirective,
    MetaValidatorDirective
  ]
})
export class GrundstueckAuszugSettingsComponent implements OnInit, OnDestroy {
  @Input()
  format: FormatEnum;
  @Input()
  title: string;
  @Input()
  auszugItem: AuszugInfoItem;
  auszugType: AuszugTypeEnum = 'Grundstueck';
  @Input()
  hasToZip: boolean;
  @Input()
  ids: Array<string>;
  @Input()
  indexNumber: number;

  isOerebEnabled: boolean;
  permissionHaengigeGeschaefte: boolean;
  hasRequiredErweiterung = false;
  public model: GrundstueckPrintOptionsMeta;
  private defaultSettings: GrundstueckPrintOptionsMeta;
  private subscription: Subscription = new Subscription();

  constructor(
    public activeModal: NgbActiveModal,
    private auszugSettingsService: AuszugSettingsService,
    private config: FormatConfigService,
    private permissionService: AppPermissionService,
    private translateService: TranslateService,
    private alerts: CapAlertService
  ) {
    keysToTranslate<string>([
      'Grundstueckbeschreibung',
      'Detaillierungsgrad',
      'AuszugBearbeiten',
      'InEinemDokumentDrucken',
      'EigentumErweitern',
      'EigentümerMitAdresseAufbereiten',
      'WeitereRechtsgründeAufbereiten',
      'StandardrechteIdsAufbereiten_DI_GL_SDR_VO_AN',
      'PfandrechtIdsAufbereiten',
      'EreidsAufbereiten',
      'VertragstexteAufbereiten',
      'HaengigeGeschaefteAufbereiten',
      'EinstellungenSpeichernBisZurNaechstenAbmeldung',
      'gegeneintraegeDITDienstbarkeitenDrucken',
      'UidBeiNatuerlichenPersonenDrucken'
    ]);
  }

  ngOnInit(): void {
    this.subscription.add(
      this.config.printConfig$.subscribe((config) => {
        this.defaultSettings = config?.getGrundstueckDefaultSettings();
        this.model = {
          ...config?.getGrundstueckAuszugOptions()
        };
      })
    );
    this.subscription.add(
      this.config.erweiterungsConfig$.subscribe((config) => {
        this.isOerebEnabled = config?.activeErweiterungen.includes(ActiveErweiterungenEnum.OEREB_CH);
        this.hasRequiredErweiterung = config?.activeErweiterungen.includes(ActiveErweiterungenEnum.GB_AUSZUG_MIT_MEHREREN_GRUNDSTUECKEN);
      })
    );
    this.permissionHaengigeGeschaefte = this.permissionService.hasPermission('ANZEIGE_DETAILS_HAENGIGE_GESCHAEFTE');
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  confirm() {
    if (!!this.ids && this.ids?.length > 20) {
      this.activeModal.close(true);
      return this.alerts.warning(this.translateService.instant('HinweismeldungAuszuege'));
    }

    const auszugPrintOption = <AuszugPrintOptions>{
      auszugType: this.auszugType,
      printOptions: this.model,
      format: this.format,
      item: this.auszugItem,
      hasToZip: this.hasToZip,
      ids: this.ids,
      indexNumber: this.indexNumber
    };
    this.auszugSettingsService.confirmPrintSelection(auszugPrintOption);
    this.activeModal.close(true);
  }

  resetSettings() {
    this.model = { ...this.defaultSettings };
  }
}
